import React from "react";
import { useDispatch, useSelector } from "react-redux";
import Select from "react-select";
import { ReduxState } from "../../../../../redux";
import { setDownloadOptionsSelectedDocumentIds } from "../../../../../redux/reducers/TransactionManager";
import { CheckboxOption } from "./utils";

type Props = {};
export const DocumentsDropdown: React.SFC<Props> = ({}) => {
  const dispatch = useDispatch();

  const { tls, downloadOptions } = useSelector(
    (state: ReduxState) => state.TransactionManager
  );
  const { documents } = tls;
  const { selectedDocumentIds, selectedFieldNames } = downloadOptions;

  const options = (documents || []).map((doc) => ({
    value: doc.id.toString(),
    label: doc.originalname,
  }));
  const selectedOptions = options.filter((option) =>
    selectedDocumentIds.includes(option.value)
  );
  return (
    <div /*style={{ overflowY: "auto", maxHeight: "350px" }}*/>
      <Select
        options={options}
        value={selectedOptions}
        onChange={(value) => {
          dispatch(
            setDownloadOptionsSelectedDocumentIds(
              ((value || []) as any).map((x) => x.value)
            )
          );
        }}
        isMulti={true}
        closeMenuOnSelect={false}
        // hideSelectedOptions={false}
        allowSelectAll={true}
        components={{
          Option: CheckboxOption,
        }}
      />
    </div>
  );
};
export default DocumentsDropdown;
